import React, { useEffect } from "react";
import '../../Components/ProductsCards/ProductCards.scss';

/**************** IMAGES ****************/
import CardImageOne from '../../assets/Images/ProductCardsImages/Image1.webp';
import CardImageTwo from '../../assets/Images/ProductCardsImages/Image2.webp';
import CardImageThree from '../../assets/Images/ProductCardsImages/Image3.webp';
import CardImageFour from '../../assets/Images/ProductCardsImages/Image4.webp';
import CardImageFive from '../../assets/Images/ProductCardsImages/Image5.webp';
import CardImageSix from '../../assets/Images/ProductCardsImages/Image6.webp';
import CardImageSeven from '../../assets/Images/ProductCardsImages/Image7.webp';
import CardImageEight from '../../assets/Images/ProductCardsImages/Image8.webp';



/* AOS LIBRARY */
import AOS from 'aos';
import 'aos/dist/aos.css';




function ProductCards() {

    /* AOS  */
    useEffect(() => {
        AOS.init();
    }, [])

    return (

        <>

            <div className="productCards_Section">
                <h2 className="ProductCards_text">Shop our Favourites</h2>

                <div className='product_Cards'>
                    <div className='cardOne' data-aos='fade-up' data-aos-duration="1000">
                        <img src={CardImageOne} />
                        <div className='card_text'>
                            <p>Aria Laptop Bag</p>
                            <p>21 reviews</p>
                            <small><span className='text-danger'> Rs. 2,388.00</span> <strike> Rs. 6,000.00</strike></small><br /><br /><br />
                            <badge className="text-bg-danger">60% off</badge>
                        </div>

                        <div className='Card_button'>
                            <button className='AddToCartButton'><a>ADD TO CART</a></button>
                        </div>
                    </div>
                    <div className='cardTWo' data-aos='fade-up' data-aos-duration="1100">
                        <img src={CardImageTwo} />
                        <div className='card_text'>
                            <p>Aria Laptop Bag</p>
                            <p>21 reviews</p>
                            <small><span className='text-danger'> Rs. 2,388.00</span> <strike> Rs. 6,000.00</strike></small><br /><br /><br />
                            <badge className="text-bg-danger">60% off</badge>
                        </div>

                        <div className='Card_button'>
                            <button className='AddToCartButton'><a>ADD TO CART</a></button>
                        </div>
                    </div>
                    <div className='cardThree' data-aos='fade-up' data-aos-duration="1200">
                        <img src={CardImageThree} />
                        <div className='card_text'>
                            <p>Aria Laptop Bag</p>
                            <p>21 reviews</p>
                            <small><span className='text-danger'> Rs. 2,388.00</span> <strike> Rs. 6,000.00</strike></small><br /><br /><br />
                            <badge className="text-bg-danger">60% off</badge>
                        </div>

                        <div className='Card_button'>
                            <button className='AddToCartButton'><a>ADD TO CART</a></button>
                        </div>
                    </div>
                    <div className='cardFour' data-aos='fade-up' data-aos-duration="1300">
                        <img src={CardImageFour} />
                        <div className='card_text'>
                            <p>Aria Laptop Bag</p>
                            <p>21 reviews</p>
                            <small><span className='text-danger'> Rs. 2,388.00</span> <strike> Rs. 6,000.00</strike></small><br /><br /><br />
                            <badge className="text-bg-danger">60% off</badge>
                        </div>

                        <div className='Card_button'>
                            <button className='AddToCartButton'><a>ADD TO CART</a></button>
                        </div>
                    </div>

                    <div className='cardOne' data-aos='fade-up' data-aos-duration="1400">
                        <img src={CardImageFive} />
                        <div className='card_text'>
                            <p>Aria Laptop Bag</p>
                            <p>21 reviews</p>
                            <small><span className='text-danger'> Rs. 2,388.00</span> <strike> Rs. 6,000.00</strike></small><br /><br /><br />
                            <badge className="text-bg-danger">60% off</badge>
                        </div>

                        <div className='Card_button'>
                            <button className='AddToCartButton'><a>ADD TO CART</a></button>
                        </div>
                    </div>
                    <div className='cardTWo' data-aos='fade-up' data-aos-duration="1500">
                        <img src={CardImageSix} />
                        <div className='card_text'>
                            <p>Aria Laptop Bag</p>
                            <p>21 reviews</p>
                            <small><span className='text-danger'> Rs. 2,388.00</span> <strike> Rs. 6,000.00</strike></small><br /><br /><br />
                            <badge className="text-bg-danger">60% off</badge>
                        </div>

                        <div className='Card_button'>
                            <button className='AddToCartButton'><a>ADD TO CART</a></button>
                        </div>
                    </div>
                    <div className='cardThree' data-aos='fade-up' data-aos-duration="1600">
                        <img src={CardImageSeven} />
                        <div className='card_text'>
                            <p>Aria Laptop Bag</p>
                            <p>21 reviews</p>
                            <small><span className='text-danger'> Rs. 2,388.00</span> <strike> Rs. 6,000.00</strike></small><br /><br /><br />
                            <badge className="text-bg-danger">60% off</badge>
                        </div>

                        <div className='Card_button'>
                            <button className='AddToCartButton'><a>ADD TO CART</a></button>
                        </div>
                    </div>
                    <div className='cardFour' data-aos='fade-up' data-aos-duration="1700">
                        <img src={CardImageEight} />
                        <div className='card_text'>
                            <p>Aria Laptop Bag</p>
                            <p>21 reviews</p>
                            <small><span className='text-danger'> Rs. 2,388.00</span> <strike> Rs. 6,000.00</strike></small><br /><br /><br />
                            <badge className="text-bg-danger">60% off</badge>
                        </div>

                        <div className='Card_button'>
                            <button className='AddToCartButton'><a>ADD TO CART</a></button>
                        </div>
                    </div>
                </div>

                <div className='ViewALLButton'>
                    <button className=''><a>VIEW ALL PRODUCTS</a></button>
                </div>
            </div>
        </>
    )
};


export default ProductCards;